import React, { Component } from "react";
import propertiesStyle from "./Properties.module.css";
import textStyles from "./Text.module.css";
import TriangleDown from "../../SVG/TriangleDown";
import TriangleRight from "../../SVG/TriangleRight";
import { setProperty as SET_PROPERTY } from "../../Scripts/PropertyUtils";
import styled from "styled-components";
import DragInput from "../DragInput/DragInput";

const Select = styled.select`
  background-color: #181d25;
  color: #fff;
  padding: 4px;
  border: none;
  margin: 4px;
  border-radius: 4px;
`;

export default class HeatMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      colorClicked: false,
      open: false,
      font: null,
      showContext: false,
    };
  }

  drag(e, property, value) {
    e.dataTransfer.setData("property", property);
    e.dataTransfer.setData("value", value);
  }

  handleContext(e, item) {
    e.preventDefault();

    this.setState({
      showContext: true,
      mouseX: e.clientX,
      mouseY: e.clientY,
    });
    window.addEventListener("click", this.handleClick.bind(this));
  }

  handleClick(e) {
    this.setState({
      showContext: false,
    });
    window.removeEventListener("click", this.handleClick.bind(this));
  }

  updateProperty(property, value) {
    SET_PROPERTY(this.props.item, property, value);

    this.setState({ update: true });
  }

  addPoint() {
    let newData = [...this.props.item.heat._data];
    newData.push([10, 10, 1]);
    this.updateProperty("heat._data", newData);
  }

  removePoint(i) {
    let newData = [...this.props.item.heat._data];
    newData.splice(i, 1);
    this.updateProperty("heat._data", newData);
  }

  colorClicked(e) {
    this.setState({
      colorClicked: !this.state.colorClicked,
    });
  }

  allowDrop(e) {
    e.preventDefault();
  }

  handleMouseDown(e, property, startValue) {
    this.property = property;
    this.mouseDown = true;
    var rect = document.querySelector("body").getBoundingClientRect();
    var x = e.clientX - rect.left; //x position within the element.
    this.startX = x;

    this.startValue = startValue;
    document.addEventListener("mousemove", this.handleMouseMove.bind(this));
    document.addEventListener("mouseup", this.handleMouseUp.bind(this));
  }

  handleMouseMove(e) {
    if (this.mouseDown) {
      var rect = document.querySelector("body").getBoundingClientRect();
      var x = e.clientX - rect.left; //x position within the element.
      x = x - this.startX;
      let value = this.startValue + x;

      if (this.property === "style.fontSize") {
        value = Math.max(value, 1);
      }

      this.updateProperty(this.property, value);

      this.updateProperty("text", this.props.item.text);
    }
  }

  handleMouseUp(e) {
    this.mouseDown = false;
    document.removeEventListener("mousemove", this.handleMouseMove.bind(this));
    document.removeEventListener("mouseup", this.handleMouseUp.bind(this));
  }

  handleColorChange(color, event) {
    // this.props.item.material.color = new THREE.Color(
    //   "rgba(" +
    //     color.rgb.r +
    //     "," +
    //     color.rgb.g +
    //     "," +
    //     color.rgb.b +
    //     "," +
    //     color.rgb.a +
    //     ")"
    // );
    this.forceUpdate();
  }

  drop(e, item) {
    if (e.dataTransfer.getData("source")) {
      if (!item.dataBinds) {
        item.dataBinds = [];
      }
      item.dataBinds.push({
        source: e.dataTransfer.getData("source"),
        property: e.dataTransfer.getData("property"),
        itemProperty: "text",
      });
    }
  }

  handleContextUnbind() {
    this.props.item.dataBinds = this.props.item.dataBinds.filter(
      (d) => d.itemProperty !== "text"
    );
    this.props.item.text = "";
    this.forceUpdate();
  }

  upload(e) {
    const files = Array.from(e.target.files);

    const formData = new FormData();

    files.forEach((file, i) => {
      formData.append("file", file);
    });

    let path_id = this.props.project?.use_project_folder
      ? this.props.project?._id
      : this.props.project.user._id;
    let prefix = this.props.project?.use_project_folder ? "project/" : "";

    fetch(`${window.projectServerURL}assets/fonts/${prefix}${path_id}`, {
      method: "POST",
      body: formData,
    }).then(() => {
      let font = new FontFace(
        files[0].name,
        "url('" +
          window.projectServerURL +
          "assets/fonts/" +
          prefix +
          path_id +
          "/" +
          files[0].name +
          "')"
      );
      font.load().then((loadedFont) => {
        window.document.fonts.add(loadedFont);
      });
    });
  }

  render() {
    let color = this.props.item.style ? "#" + this.props.item.style._fill : "";

    let text =
      this.props.item.dataBinds &&
      this.props.item.dataBinds.find((bind) => bind.itemProperty === "text")
        ? this.props.item.dataBinds.find((bind) => bind.itemProperty === "text")
            .property
        : this.props.item._text;
    let fonts = window.document.fonts.entries();
    let done = false;
    let font_array = [];

    while (!done) {
      const font = fonts.next();
      if (!font.done) {
        font_array.push(font.value[0]);
        // console.log(font.value[0])
      } else {
        done = font.done;
      }
    }

    return (
      <div className={propertiesStyle.Group}>
        <div
          className={propertiesStyle.GroupTitle}
          onClick={() => this.setState({ open: !this.state.open })}
        >
          <div className={propertiesStyle.Open}>
            {this.state.open && <TriangleDown />}
            {!this.state.open && <TriangleRight />}
          </div>
          <div className={propertiesStyle.Title}>Heatmap Data</div>
        </div>
        {this.state.open && (
          <div className={textStyles.Group}>
            <div className={textStyles.Property}>
              <label>Data</label>
              
              {this.props.item.heat._data.map((points, i) => (
                <div style={{display: "flex", flexDirection: "row", alignItems: "center", marginBottom: "4px"}} key={i}>
                  <input value={points[0]} onChange={(e) => {
                    let newData = [...this.props.item.heat._data];
                    newData[i][0] = parseFloat(e.target.value);
                    this.updateProperty("heat._data", newData);
                  }} />
                  <input value={points[1]} onChange={(e) => {
                    let newData = [...this.props.item.heat._data];
                    newData[i][1] = parseFloat(e.target.value);
                    this.updateProperty("heat._data", newData);
                  }} />
                  <input value={points[2]} onChange={(e) => {
                    let newData = [...this.props.item.heat._data];
                    newData[i][2] = parseFloat(e.target.value);
                    this.updateProperty("heat._data", newData);
                  }} />
                  <button onClick={() => this.removePoint(i)} style={{marginLeft: "8px", padding: "4px 8px", backgroundColor: "#db0a41", color: "white", border: "none", borderRadius: "4px", cursor: "pointer"}}>Remove</button>
                  </div>
              ))}
              <button onClick={() => this.addPoint()} style={{marginTop: "8px", padding: "4px 8px", backgroundColor: "#38e086", color: "black", border: "none", borderRadius: "4px", cursor: "pointer"}}>Add Point</button>
            </div>
          </div>
        )}
      </div>
    );
  }
}
